import { doc, getDoc } from "firebase/firestore";
import { firestore } from "../firebase";
import { TrackData } from "../types/Types";

const TOP_100_CHART_DOC_ID = "9gYzl8127rQ9kosWpRCy";

export const Top100Service = {

    fetchTop100Tracks: async (): Promise<TrackData[]> => {
        try {
            const chartRef = doc(firestore, "top100Chart", TOP_100_CHART_DOC_ID);
            const chartSnap = await getDoc(chartRef);

            if (!chartSnap.exists()) return [];

            const data = chartSnap.data();
            const chartTrackIDs = data?.chartTrackIDs as string[] | undefined;

            if (!chartTrackIDs || chartTrackIDs.length === 0) return [];

            const top100IDs = chartTrackIDs.slice(0, 100);

            const trackPromises = top100IDs.map(async (trackID, index) => {
                try {
                    const trackRef = doc(firestore, "trackLinks", trackID);
                    const trackSnap = await getDoc(trackRef);

                    if (trackSnap.exists()) {
                        const t = trackSnap.data();

                        let finalUserName = t.userName || "";

                        if (!finalUserName && t.userId) {
                            try {
                                const userRef = doc(firestore, "users", t.userId);
                                const userSnap = await getDoc(userRef);
                                if (userSnap.exists()) {
                                    finalUserName = userSnap.data().userName || "";
                                }
                            } catch (err) {
                                console.error(`Error fetching user profile for ${t.userId}`, err);
                            }
                        }

                        return {
                            id: trackSnap.id,
                            rank: index + 1,
                            userId: t.userId || "",
                            stateID: t.stateID || 0,
                            regionID: t.regionID || 0,
                            coverArtUrl: t.coverArtUrl || "",
                            userName: finalUserName || "Unknown User",
                            trackTitle: t.trackTitle || "Unknown Title",
                            artistName: t.artistName || "Unknown Artist",
                            featureArtists: t.featureArtists || [],
                            genreName: t.genre || "",
                            releaseType: t.releaseType || "",
                            platformLinks: t.platformLinks || {},
                            moodTags: t.moodTags || []
                        } as TrackData;
                    }
                } catch (err) {
                    console.error(`Error fetching track ${trackID}`, err);
                }
                return null;
            });

            const fetchedTracks = await Promise.all(trackPromises);
            return fetchedTracks.filter((track): track is TrackData => track !== null);

        } catch (error) {
            console.error("Error fetching Top 100 tracks:", error);
            return [];
        }
    },
};